{
  "labels": {
    "paste": "Colar",
    "pasteAsPlaintext": "Colar como texto sem formatação",
    "pasteCharts": "Colar gráficos",
    "selectAll": "Selecionar tudo",
    "multiSelect": "Adicionar elemento à seleção",
    "moveCanvas": "Mover tela",
    "cut": "Recortar",
    "copy": "Copiar",
    "copyAsPng": "Copiar para a área de transferência como PNG",
    "copyAsSvg": "Copiar para a área de transferência como SVG",
    "copyText": "Copiar para área de transferência como texto",
    "copySource": "Copiar fonte para área de transferência",
    "convertToCode": "Converter para código",
    "bringForward": "Trazer para a frente",
    "sendToBack": "Enviar para o fundo",
    "bringToFront": "Trazer para o primeiro plano",
    "sendBackward": "Enviar para trás",
    "delete": "Apagar",
    "copyStyles": "Copiar os estilos",
    "pasteStyles": "Colar os estilos",
    "stroke": "Contorno",
    "changeStroke": "Alterar cor da borda",
    "background": "Fundo",
    "changeBackground": "Alterar cor de fundo",
    "fill": "Preenchimento",
    "strokeWidth": "Espessura do traço",
    "strokeStyle": "Estilo do traço",
    "strokeStyle_solid": "Sólido",
    "strokeStyle_dashed": "Tracejado",
    "strokeStyle_dotted": "Pontilhado",
    "sloppiness": "Precisão do traço",
    "opacity": "Opacidade",
    "textAlign": "Alinhamento do texto",
    "edges": "Arestas",
    "sharp": "Pontudo",
    "round": "Arredondado",
    "arrowheads": "Pontas",
    "arrowhead_none": "Nenhuma",
    "arrowhead_arrow": "Flecha",
    "arrowhead_bar": "Barra",
    "arrowhead_circle": "Círculo",
    "arrowhead_circle_outline": "Circulo (contorno)",
    "arrowhead_triangle": "Triângulo",
    "arrowhead_triangle_outline": "Triângulo (contorno)",
    "arrowhead_diamond": "Diamante",
    "arrowhead_diamond_outline": "Diamante (contorno)",
    "arrowhead_crowfoot_many": "Pé de pássaro (muitos)",
    "arrowhead_crowfoot_one": "Pé de pássaro (um)",
    "arrowhead_crowfoot_one_or_many": "Pé de pássaro (um ou muitos)",
    "more_options": "Mais opções",
    "arrowtypes": "Tipo de seta",
    "arrowtype_sharp": "Seta afiada",
    "arrowtype_round": "Seta curva",
    "arrowtype_elbowed": "Seta dobrada",
    "fontSize": "Tamanho da fonte",
    "fontFamily": "Família da fonte",
    "addWatermark": "Adicionar \"Feito com Excalidraw\"",
    "handDrawn": "Manuscrito",
    "normal": "Normal",
    "code": "Código",
    "small": "Pequeno",
    "medium": "Médio",
    "large": "Grande",
    "veryLarge": "Muito grande",
    "solid": "Sólido",
    "hachure": "Hachura",
    "zigzag": "Zigue-zague",
    "crossHatch": "Hachura cruzada",
    "thin": "Fino",
    "bold": "Espesso",
    "left": "Esquerda",
    "center": "Centralizar",
    "right": "Direita",
    "extraBold": "Muito espesso",
    "architect": "Arquiteto",
    "artist": "Artista",
    "cartoonist": "Cartunista",
    "fileTitle": "Nome do arquivo",
    "colorPicker": "Seletor de cores",
    "canvasColors": "Usado na tela",
    "canvasBackground": "Fundo da tela",
    "drawingCanvas": "Tela de desenho",
    "clearCanvas": "Limpar a tela",
    "layers": "Camadas",
    "actions": "Ações",
    "language": "Idioma",
    "liveCollaboration": "Colaboração ao vivo...",
    "duplicateSelection": "Duplicar",
    "untitled": "Sem título",
    "name": "Nome",
    "yourName": "Seu nome",
    "madeWithExcalidraw": "Feito com Excalidraw",
    "group": "Agrupar seleção",
    "ungroup": "Desagrupar seleção",
    "collaborators": "Colaboradores",
    "toggleGrid": "Alternar grade",
    "addToLibrary": "Adicionar à biblioteca",
    "removeFromLibrary": "Remover da biblioteca",
    "libraryLoadingMessage": "Carregando biblioteca…",
    "libraries": "Procurar bibliotecas",
    "loadingScene": "Carregando cena…",
    "loadScene": "Carregar cenário de arquivo",
    "align": "Alinhamento",
    "alignTop": "Alinhar ao topo",
    "alignBottom": "Alinhar embaixo",
    "alignLeft": "Alinhar à esquerda",
    "alignRight": "Alinhar à direita",
    "centerVertically": "Centralizar verticalmente",
    "centerHorizontally": "Centralizar horizontalmente",
    "distributeHorizontally": "Distribuir horizontalmente",
    "distributeVertically": "Distribuir verticalmente",
    "flipHorizontal": "Inverter horizontalmente",
    "flipVertical": "Inverter verticalmente",
    "viewMode": "Modo de visualização",
    "share": "Compartilhar",
    "showStroke": "Exibir seletor de cores do traço",
    "showBackground": "Exibir seletor de cores do fundo",
    "showFonts": "Exibir seletor de fonte",
    "toggleTheme": "Alternar tema claro/escuro",
    "theme": "Tema",
    "personalLib": "Biblioteca Pessoal",
    "excalidrawLib": "Biblioteca do Excalidraw",
    "decreaseFontSize": "Diminuir o tamanho da fonte",
    "increaseFontSize": "Aumentar o tamanho da fonte",
    "unbindText": "Desvincular texto",
    "bindText": "Vincular texto ao contêiner",
    "createContainerFromText": "Envolver texto em um contêiner",
    "link": {
      "edit": "Editar link",
      "editEmbed": "Editar link incorporável",
      "create": "Adicionar link",
      "label": "Link",
      "labelEmbed": "Vincular e incorporar",
      "empty": "Nenhum link foi definido",
      "hint": "Digite ou cole o seu link aqui",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "Editar linha",
      "editArrow": "Editar seta"
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "Bloquear",
      "unlock": "Desbloquear",
      "lockAll": "Bloquear tudo",
      "unlockAll": "Desbloquear tudo"
    },
    "statusPublished": "Publicado",
    "sidebarLock": "Manter barra lateral aberta",
    "selectAllElementsInFrame": "Selecionar todos os elementos no quadro",
    "removeAllElementsFromFrame": "Remover todos os elementos do quadro",
    "eyeDropper": "Escolher cor da tela",
    "textToDiagram": "Texto para diagrama",
    "prompt": "Prompt",
    "followUs": "Siga-nos",
    "discordChat": "Discord",
    "zoomToFitViewport": "Zoom para caber na tela",
    "zoomToFitSelection": "Ampliar para ajustar a seleção",
    "zoomToFit": "Ampliar para encaixar todos os elementos",
    "installPWA": "Instalar excalidraw localmente (PWA)",
    "autoResize": "Habilitar redimensionamento automático de texto",
    "imageCropping": "Recorte de imagem",
    "unCroppedDimension": "Dimensão sem recortes",
    "copyElementLink": "Copiar link para o objeto",
    "linkToElement": "Links para o objeto",
    "wrapSelectionInFrame": "Ajustar seleção no frame",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "",
    "desc": "Clique em uma forma na tela ou cole um link.",
    "notFound": "Objeto vinculado não foi encontrado na tela."
  },
  "library": {
    "noItems": "Nenhum item adicionado ainda...",
    "hint_emptyLibrary": "Selecione um item na tela para adicioná-lo aqui, ou instale uma biblioteca do repositório público, abaixo.",
    "hint_emptyPrivateLibrary": "Selecione um item na tela para adicioná-lo aqui.",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "Procurar na tela",
    "noMatch": "Nenhum resultado encontrado...",
    "singleResult": "resultado",
    "multipleResults": "resultados",
    "placeholder": "Procurar texto na tela...",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "Limpar a tela",
    "exportJSON": "Exportar arquivo",
    "exportImage": "Exportar imagem...",
    "export": "Salvar como...",
    "copyToClipboard": "Copiar para a área de transferência",
    "copyLink": "Copiar link",
    "save": "Salvar para o arquivo atual",
    "saveAs": "Salvar como",
    "load": "Abrir",
    "getShareableLink": "Obter um link de compartilhamento",
    "close": "Fechar",
    "selectLanguage": "Selecionar idioma",
    "scrollBackToContent": "Voltar para o conteúdo",
    "zoomIn": "Aumentar zoom",
    "zoomOut": "Diminuir zoom",
    "resetZoom": "Redefinir zoom",
    "menu": "Menu",
    "done": "Concluído",
    "edit": "Editar",
    "undo": "Desfazer",
    "redo": "Refazer",
    "resetLibrary": "Redefinir biblioteca",
    "createNewRoom": "Criar nova sala",
    "fullScreen": "Tela cheia",
    "darkMode": "Modo escuro",
    "lightMode": "Modo claro",
    "systemMode": "Modo do sistema",
    "zenMode": "Modo Zen",
    "objectsSnapMode": "Encaixar em objetos",
    "exitZenMode": "Sair do modo zen",
    "cancel": "Cancelar",
    "saveLibNames": "",
    "clear": "Limpar",
    "remove": "Remover",
    "embed": "Alternar incorporação",
    "publishLibrary": "Renomear ou publicar",
    "submit": "Enviar",
    "confirm": "Confirmar",
    "embeddableInteractionButton": "Clique para interagir"
  },
  "alerts": {
    "clearReset": "Isto irá limpar toda a tela. Você tem certeza?",
    "couldNotCreateShareableLink": "Não foi possível criar um link de compartilhamento.",
    "couldNotCreateShareableLinkTooBig": "Não foi possível criar um link compartilhável: a cena é muito grande",
    "couldNotLoadInvalidFile": "Não foi possível carregar o arquivo inválido",
    "importBackendFailed": "A importação do servidor falhou.",
    "cannotExportEmptyCanvas": "Não é possível exportar uma tela vazia.",
    "couldNotCopyToClipboard": "Não foi possível copiar para a área de transferência.",
    "decryptFailed": "Não foi possível descriptografar os dados.",
    "uploadedSecurly": "O upload foi protegido com criptografia de ponta a ponta, o que significa que o servidor do Excalidraw e terceiros não podem ler o conteúdo.",
    "loadSceneOverridePrompt": "Carregar um desenho externo substituirá o seu conteúdo existente. Deseja continuar?",
    "collabStopOverridePrompt": "Ao interromper a sessão, você substituirá seu desenho anterior, armazenado localmente. Você tem certeza?\n\n(Se você deseja manter seu desenho local, simplesmente feche a aba do navegador.)",
    "errorAddingToLibrary": "Não foi possível adicionar o item à biblioteca",
    "errorRemovingFromLibrary": "Não foi possível remover o item da biblioteca",
    "confirmAddLibrary": "Isso adicionará {{numShapes}} forma(s) à sua biblioteca. Tem certeza?",
    "imageDoesNotContainScene": "Esta imagem parece não conter dados de cenas. Você ativou a incorporação da cena durante a exportação?",
    "cannotRestoreFromImage": "Não foi possível restaurar a cena deste arquivo de imagem",
    "invalidSceneUrl": "Não foi possível importar a cena da URL fornecida. Ela está incompleta ou não contém dados JSON válidos do Excalidraw.",
    "resetLibrary": "Isto limpará a sua biblioteca. Você tem certeza?",
    "removeItemsFromsLibrary": "Excluir {{count}} item(ns) da biblioteca?",
    "invalidEncryptionKey": "A chave de encriptação deve ter 22 caracteres. A colaboração ao vivo está desabilitada.",
    "collabOfflineWarning": "Sem conexão com a internet disponível.\nSuas alterações não serão salvas!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Tipo de arquivo não suportado.",
    "imageInsertError": "Não foi possível inserir imagem. Tente novamente mais tarde...",
    "fileTooBig": "O arquivo é muito grande. O tamanho máximo permitido é {{maxSize}}.",
    "svgImageInsertError": "Não foi possível inserir a imagem SVG. A marcação SVG parece inválida.",
    "failedToFetchImage": "Falha ao buscar imagem.",
    "cannotResolveCollabServer": "Não foi possível conectar-se ao servidor colaborativo. Por favor, recarregue a página e tente novamente.",
    "importLibraryError": "Não foi possível carregar a biblioteca",
    "saveLibraryError": "Não foi possível salvar a biblioteca no armazenamento. Salve sua biblioteca em um arquivo localmente para garantir que você não perca as alterações.",
    "collabSaveFailed": "Não foi possível salvar no banco de dados do servidor. Se os problemas persistirem, salve o arquivo localmente para garantir que não perca o seu trabalho.",
    "collabSaveFailed_sizeExceeded": "Não foi possível salvar no banco de dados do servidor, a tela parece ser muito grande. Se os problemas persistirem, salve o arquivo localmente para garantir que não perca o seu trabalho.",
    "imageToolNotSupported": "Imagens estão desabilitadas.",
    "brave_measure_text_error": {
      "line1": "Parece que você está usando o navegador Brave com a configuração <bold>Bloquear Impressões Digitais</bold> no modo agressivo.",
      "line2": "Isso pode acabar quebrando <bold>Elementos de Texto</bold> em seus desenhos.",
      "line3": "Recomendamos fortemente desativar essa configuração. Você pode acessar o <link>passo a passo</link> sobre como fazer isso.",
      "line4": "Se desativar essa configuração não corrigir a exibição de elementos de texto, por favor abra uma <issueLink>issue</issueLink> em nosso GitHub, ou mande uma mensagem em nosso <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "Elementos incorporáveis não podem ser adicionados à biblioteca.",
      "iframe": "Elementos do IFrame não podem ser adicionados à biblioteca.",
      "image": "Suporte para adicionar imagens à biblioteca em breve!"
    },
    "asyncPasteFailedOnRead": "Não foi possível colar (não foi possível ler da área de transferência do sistema).",
    "asyncPasteFailedOnParse": "Não foi possível colar.",
    "copyToSystemClipboardFailed": "Não foi possível copiar para a área de transferência."
  },
  "toolBar": {
    "selection": "Seleção",
    "lasso": "",
    "image": "Inserir imagem",
    "rectangle": "Retângulo",
    "diamond": "Losango",
    "ellipse": "Elipse",
    "arrow": "Flecha",
    "line": "Linha",
    "freedraw": "Desenhar",
    "text": "Texto",
    "library": "Biblioteca",
    "lock": "Manter ativa a ferramenta selecionada após desenhar",
    "penMode": "Modo caneta — impede o toque",
    "link": "Adicionar / Atualizar link para uma forma selecionada",
    "eraser": "Borracha",
    "frame": "Ferramenta de quadro",
    "magicframe": "Wireframe para código",
    "embeddable": "Página web incorporada",
    "laser": "Ponteiro de laser",
    "hand": "Mão (ferramenta de rolagem)",
    "extraTools": "Mais ferramentas",
    "mermaidToExcalidraw": "Mermaid para Excalidraw",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "Retângulo",
    "diamond": "Diamante",
    "ellipse": "Elipse",
    "arrow": "Seta",
    "line": "Linha",
    "freedraw": "Desenho livre",
    "text": "Texto",
    "image": "Imagem",
    "group": "Grupo",
    "frame": "Moldura",
    "magicframe": "Wireframe para código",
    "embeddable": "Página web incorporada",
    "selection": "Seleção",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Ações da tela",
    "selectedShapeActions": "Ações das formas selecionadas",
    "shapes": "Formas"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "Clique para iniciar vários pontos, arraste para uma única linha",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Toque e arraste, solte quando terminar",
    "text": "Dica: você também pode adicionar texto clicando duas vezes em qualquer lugar com a ferramenta de seleção",
    "embeddable": "Clique e arraste para criar um site incorporado",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "Publicar sua própria biblioteca",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "Esse recurso pode ser ativado configurando a opção \"dom.events.asyncClipboard.clipboardItem\" como \"true\". Para alterar os sinalizadores do navegador no Firefox, visite a página \"about:config\".",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "Não é possível mostrar pré-visualização",
    "canvasTooBig": "A tela pode ser muito grande.",
    "canvasTooBigTip": "Dica: tente aproximar um pouco os elementos mais distantes."
  },
  "errorSplash": {
    "headingMain": "Foi encontrado um erro. Tente <button>recarregar a página.</button>",
    "clearCanvasMessage": "Se recarregar a página não funcionar, tente <button>limpando a tela.</button>",
    "clearCanvasCaveat": " Isso resultará em perda de trabalho ",
    "trackedToSentry": "O erro com o identificador {{eventId}} foi rastreado no nosso sistema.",
    "openIssueMessage": "Fomos muito cautelosos para não incluir suas informações de cena no erro. Se sua cena não for privada, por favor, considere seguir nosso <button>rastreador de bugs.</button> Por favor, inclua informações abaixo, copiando e colando para a issue do GitHub.",
    "sceneContent": "Conteúdo da cena:"
  },
  "shareDialog": {
    "or": "Ou"
  },
  "roomDialog": {
    "desc_intro": "Convide pessoas para colaborar em seu desenho.",
    "desc_privacy": "Não se preocupe, a sessão é criptografada de ponta a ponta e totalmente privada. Nem mesmo nosso servidor pode ver o que você desenha.",
    "button_startSession": "Iniciar sessão",
    "button_stopSession": "Parar sessão",
    "desc_inProgressIntro": "A sessão de colaboração ao vivo está agora em andamento.",
    "desc_shareLink": "Compartilhe este link com qualquer pessoa com quem você queira colaborar:",
    "desc_exitSession": "Interrompendo a sessão você irá se desconectar da sala, mas você poderá continuar trabalhando com a cena localmente. Observe que isso não afetará outras pessoas, e elas ainda poderão colaborar em suas versões.",
    "shareTitle": "Participe de uma sessão ao vivo de colaboração no Excalidraw"
  },
  "errorDialog": {
    "title": "Erro"
  },
  "exportDialog": {
    "disk_title": "Salvar no computador",
    "disk_details": "Exportar os dados da cena para um arquivo que você poderá importar mais tarde.",
    "disk_button": "Salvar em um arquivo",
    "link_title": "Link compartilhável",
    "link_details": "Exportar como link de somente leitura.",
    "link_button": "Exportar link",
    "excalidrawplus_description": "Salvar a cena na sua área de trabalho Excalidraw+.",
    "excalidrawplus_button": "Exportar",
    "excalidrawplus_exportError": "Não é possível exportar para o Excalidraw+ neste momento..."
  },
  "helpDialog": {
    "blog": "Leia o nosso blog",
    "click": "clicar",
    "deepSelect": "Seleção profunda",
    "deepBoxSelect": "Use a seleção profunda dentro da caixa para previnir arrastar",
    "createFlowchart": "Crie um fluxograma a partir de um elemento genérico",
    "navigateFlowchart": "Navegar por um fluxograma",
    "curvedArrow": "Seta curva",
    "curvedLine": "Linha curva",
    "documentation": "Documentação",
    "doubleClick": "clique duplo",
    "drag": "arrastar",
    "editor": "Editor",
    "editLineArrowPoints": "Editar linha/ponta da seta",
    "editText": "Editar texto / adicionar etiqueta",
    "github": "Encontrou algum problema? Nos informe",
    "howto": "Siga nossos guias",
    "or": "ou",
    "preventBinding": "Evitar fixação de seta",
    "tools": "Ferramentas",
    "shortcuts": "Atalhos de teclado",
    "textFinish": "Encerrar edição (editor de texto)",
    "textNewLine": "Adicionar nova linha (editor de texto)",
    "title": "Ajuda",
    "view": "Visualizar",
    "zoomToFit": "Ampliar para encaixar todos os elementos",
    "zoomToSelection": "Ampliar a seleção",
    "toggleElementLock": "Bloquear/desbloquear seleção",
    "movePageUpDown": "Mover a página para cima/baixo",
    "movePageLeftRight": "Mover a página para esquerda/direita",
    "cropStart": "Recortar imagem",
    "cropFinish": "Finalizar corte da imagem"
  },
  "clearCanvasDialog": {
    "title": "Limpar a tela"
  },
  "publishDialog": {
    "title": "Publicar biblioteca",
    "itemName": "Nome do item",
    "authorName": "Nome do autor",
    "githubUsername": "Nome de usuário do GitHub",
    "twitterUsername": "Nome de usuário do Twitter",
    "libraryName": "Nome da Biblioteca",
    "libraryDesc": "Descrição da biblioteca",
    "website": "Site",
    "placeholder": {
      "authorName": "Seu nome ou nome de usuário",
      "libraryName": "Nome da sua biblioteca",
      "libraryDesc": "Descrição para ajudar as pessoas a entenderem o uso da sua biblioteca",
      "githubHandle": "Identificador do GitHub (opcional), para que você possa editar a biblioteca depois de enviar para revisão",
      "twitterHandle": "Nome de usuário do Twitter (opcional), para que saibamos quem deve ser creditado se promovermos no Twitter",
      "website": "Link para o seu site pessoal ou outro lugar (opcional)"
    },
    "errors": {
      "required": "Obrigatório",
      "website": "Informe uma URL válida"
    },
    "noteDescription": "Envie sua biblioteca para ser incluída no <link>repositório de biblioteca pública</link>para outras pessoas usarem em seus desenhos.",
    "noteGuidelines": "A biblioteca precisa ser aprovada manualmente primeiro. Por favor, leia o <link>orientações</link> antes de enviar. Você precisará de uma conta do GitHub para se comunicar e fazer alterações quando solicitado, mas não é estritamente necessário.",
    "noteLicense": "Ao enviar, você concorda que a biblioteca será publicada sob a <link>Licença MIT, </link>o que, em suma, significa que qualquer pessoa pode utilizá-los sem restrições.",
    "noteItems": "Cada item da biblioteca deve ter seu próprio nome para que seja filtrável. Os seguintes itens da biblioteca serão incluídos:",
    "atleastOneLibItem": "Por favor, selecione pelo menos um item da biblioteca para começar",
    "republishWarning": "Nota: alguns dos itens selecionados estão marcados como já publicado/enviado. Você só deve reenviar itens ao atualizar uma biblioteca existente ou submissão."
  },
  "publishSuccessDialog": {
    "title": "Biblioteca enviada",
    "content": "Obrigado {{authorName}}. Sua biblioteca foi enviada para análise. Você pode acompanhar o status <link>aqui</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Redefinir biblioteca",
    "removeItemsFromLib": "Remover itens selecionados da biblioteca"
  },
  "imageExportDialog": {
    "header": "Exportar imagem",
    "label": {
      "withBackground": "Fundo",
      "onlySelected": "Somente selecionados",
      "darkMode": "Modo escuro",
      "embedScene": "Incorporar cena",
      "scale": "Escala",
      "padding": "Margem interna"
    },
    "tooltip": {
      "embedScene": "Os dados da cena serão salvos no arquivo PNG/SVG exportado para que a cena possa ser restaurada a partir dele.\nIsso aumentará o tamanho do arquivo exportado."
    },
    "title": {
      "exportToPng": "Exportar como PNG",
      "exportToSvg": "Exportar como SVG",
      "copyPngToClipboard": "Copiar PNG para área de transferência"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Copiar para a área de transferência"
    }
  },
  "encrypted": {
    "tooltip": "Seus desenhos são criptografados de ponta a ponta, então os servidores do Excalidraw nunca os verão.",
    "link": "Publicação de blog com criptografia de ponta a ponta no Excalidraw"
  },
  "stats": {
    "angle": "Ângulo",
    "shapes": "Formas",
    "height": "Altura",
    "scene": "Cena",
    "selected": "Selecionado",
    "storage": "Armazenamento",
    "fullTitle": "Propriedades da Tela e da Forma",
    "title": "Propriedades",
    "generalStats": "Geral",
    "elementProperties": "Propriedades da forma",
    "total": "Total",
    "version": "Versão",
    "versionCopy": "Clique para copiar",
    "versionNotAvailable": "Versão não disponível",
    "width": "Largura"
  },
  "toast": {
    "addedToLibrary": "Adicionado à biblioteca",
    "copyStyles": "Estilos copiados.",
    "copyToClipboard": "Copiado para área de transferência.",
    "copyToClipboardAsPng": "{{exportSelection}} copiado para a área de transferência como PNG ({{exportColorScheme}})",
    "copyToClipboardAsSvg": "Copiado {{exportSelection}} para a área de transferência com SVG ({{exportColorScheme}})",
    "fileSaved": "Arquivo salvo.",
    "fileSavedToFilename": "Salvo em {filename}",
    "canvas": "tela",
    "selection": "seleção",
    "pasteAsSingleElement": "Use {{shortcut}} para colar como um único elemento,\nou cole em um editor de texto já existente",
    "unableToEmbed": "No momento não é permitido incorporar esta URL. Crie uma issue no GitHub para solicitar a lista branca da URL",
    "unrecognizedLinkFormat": "O link incorporado não corresponde ao formato esperado. Por favor, tente colar a string 'incorporada' que foi fornecida pelo site de origem",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "Transparente",
    "black": "Preto",
    "white": "Branco",
    "red": "Vermelho",
    "pink": "Rosa",
    "grape": "Uva",
    "violet": "Violeta",
    "gray": "Cinza",
    "blue": "Azul",
    "cyan": "Ciano",
    "teal": "Verde-azulado",
    "green": "Verde",
    "yellow": "Amarelo",
    "orange": "Laranja",
    "bronze": "Bronze"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "Você queria ir para o Excalidraw+ em vez disso?",
      "menuHint": "Exportar, preferências, idiomas..."
    },
    "defaults": {
      "menuHint": "Exportar, preferências e mais...",
      "center_heading": "Diagramas, Feito. Simples.",
      "toolbarHint": "Escolha uma ferramenta e comece a desenhar!",
      "helpHint": "Atalhos e ajuda"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "Cores personalizadas mais usadas",
    "colors": "Cores",
    "shades": "Tons",
    "hexCode": "Código hexadecimal",
    "noShades": "Sem tons disponíveis para essa cor"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exportar como imagem",
        "button": "Exportar como imagem",
        "description": "Exportar os dados da cena para um arquivo que você poderá importar mais tarde."
      },
      "saveToDisk": {
        "title": "Salvar no computador",
        "button": "Salvar no computador",
        "description": "Exportar os dados da cena para um arquivo que você poderá importar mais tarde."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Exportar para Excalidraw+",
        "description": "Salvar a cena na sua área de trabalho Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Carregar de arquivo",
        "button": "Carregar de arquivo",
        "description": "Carregar de um arquivo irá <bold> substituir o conteúdo existente</bold>.<br></br>Você pode salvar seu desenho primeiro usando uma das opções abaixo."
      },
      "shareableLink": {
        "title": "Carregar de um link",
        "button": "Substituir meu conteúdo",
        "description": "Carregar um desenho externo irá <bold> substituir seu conteúdo existente</bold>.<br></br>Você pode salvar seu desenho antes utilizando uma das opções abaixo."
      }
    }
  },
  "mermaid": {
    "title": "Mermaid para Excalidraw",
    "button": "Inserir",
    "description": "Atualmente apenas os diagramas<flowchartLink>Flowchart</flowchartLink><sequenceLink>Sequência,</sequenceLink> e <classLink>Class</classLink>são suportados. Os outros tipos serão renderizados como uma imagem no Excalidraw.",
    "syntax": "Sintaxe em Mermaid",
    "preview": "Visualizar",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": "Busca rápida"
  },
  "fontList": {
    "badge": {
      "old": "antigo"
    },
    "sceneFonts": "Neste cenário",
    "availableFonts": "Fontes disponíveis",
    "empty": "Nenhuma fonte encontrada"
  },
  "userList": {
    "empty": "Nenhum usuário encontrado",
    "hint": {
      "text": "Clique no usuário para seguir",
      "followStatus": "Atualmente você está seguindo este usuário",
      "inCall": "O usuário está em uma chamada de voz",
      "micMuted": "O microfone do usuário está silenciado",
      "isSpeaking": "O usuário está falando"
    }
  },
  "commandPalette": {
    "title": "Paleta de comandos",
    "shortcuts": {
      "select": "Selecionar",
      "confirm": "Confirmar",
      "close": "Fechar"
    },
    "recents": "Usado recentemente",
    "search": {
      "placeholder": "Procure menus, comandos e descubra gemas ocultas",
      "noMatch": "Nenhum comando correspondente..."
    },
    "itemNotAvailable": "Comando indisponível...",
    "shortcutHint": "Para a paleta de comandos, use {{shortcut}}"
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
